import { FC } from 'react';
import { SubmitButton } from '@/components/form/submit-button';
import { Button } from '@/components/ui/button';
import { strings } from '@/constants/strings';
import { useForm } from '@/forms/hooks/use-form';
import { OrganisationFieldValues } from '@/forms/schemas/organisation/field-values';
import { organisationFormSchema } from '@/forms/schemas/organisation/schema';
import { DrawerContentFormLayout } from '@/layouts/drawer-content-form-layout';

export type CreateOrganisationFormProps = {
  onCancel: () => void;
  onSubmit: (values: OrganisationFieldValues) => void;
};

// TODO: add info bar
export const CreateOrganisationForm: FC<CreateOrganisationFormProps> = ({
  onCancel,
  onSubmit,
}) => {
  const { fieldItems, handleSubmit } = useForm({
    schema: organisationFormSchema,
    onSubmit,
  });

  return (
    <DrawerContentFormLayout
      buttonItems={[
        <Button key="cancel" onClick={onCancel} variant="secondary">
          {strings.organisations.drawer_create_form.cancel}
        </Button>,
        <SubmitButton
          key="submit"
          text={strings.organisations.drawer_create_form.submit}
        />,
      ]}
      fieldItems={fieldItems}
      onSubmit={handleSubmit}
    />
  );
};
